/** Tracks in-flight requests from `getAxiosInstance` for a global loading overlay. */

let count = 0;
const listeners = new Set();

function emit() {
  listeners.forEach((listener) => listener());
}

export function subscribeApiLoading(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function getApiLoadingCount() {
  return count;
}

export function beginApiRequest() {
  count += 1;
  emit();
}

export function endApiRequest() {
  count = Math.max(0, count - 1);
  emit();
}
